import { render, staticRenderFns } from "./FooterCustom.vue?vue&type=template&id=dbb7ed56&scoped=true&"
import script from "./FooterCustom.vue?vue&type=script&lang=js&"
export * from "./FooterCustom.vue?vue&type=script&lang=js&"
import style0 from "./FooterCustom.vue?vue&type=style&index=0&id=dbb7ed56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb7ed56",
  null
  
)

export default component.exports